import { FC, useState } from "react";
import styles from "./CatalogCards.module.scss";
import { CatalogCard } from "@/lib/ui/components/Cards/CatalogCards";
import { Pagination } from "@/lib/ui/components/Pagination";
import { useTranslation } from "next-i18next";
import { ICatalogObject } from "@/lib/types/catalogPage";
import cl from "classnames";

interface ICatalogCards {
  propertiesData: ICatalogObject[];
  currentPage: number;
  maxPage: number;
  jumpToPage: (arg: number) => void;
  setNextPage: () => void;
  isLoading: boolean;
  setPrevPage: () => void;
}
export const CatalogCards: FC<ICatalogCards> = ({
  propertiesData,
  currentPage,
  jumpToPage,
  maxPage,
  setNextPage,
  setPrevPage,
  isLoading,
}) => {
  const { i18n } = useTranslation();
  const [isTouchedCard, setIsTouchedCard] = useState<string | null>(null);

  const onTouchStart = (value: string | null) => {
    if (isTouchedCard !== value) {
      setIsTouchedCard(value);
    }
  };
  return (
    <div className={cl(styles.cards, isLoading && styles["cards--loading"])}>
      <div className={styles.cards__grid}>
        {propertiesData.map((item, i) => (
          <CatalogCard
            key={i}
            data={item}
            theme={"list"}
            path={`/${i18n.language}/${item.catalogUrl}`}
            onTouchStart={onTouchStart}
            isTouchedCard={isTouchedCard}
            isFirstCard={i === 0}
          />
        ))}
      </div>
      <Pagination
        className={styles.properties__pagination}
        currentPage={currentPage}
        jumpToPage={jumpToPage}
        maxPages={maxPage}
        setNext={setNextPage}
        setPrev={setPrevPage}
      />
    </div>
  );
};
